import React, { useState } from 'react';
import axios from 'axios';
import { Box, Container, TextField, Button } from '@mui/material';
import PrimaryHeading from '../../Utilities/PrimaryHeading';
import NCRFormLabel from '../../Utilities/NCRFormLabel';
import toast from 'react-hot-toast';

export default function EmailForm({ emailFormRef }) {

  const [formData, setFormData] = useState({ name: "", email: "", requirement: "" });
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: "" });
  };

  const validateForm = () => {
    let newErrors = {};
    if (!formData.name.trim()) newErrors.name = "Name is required.";
    if (!formData.email.trim()) newErrors.email = "Email is required.";
    else if (!/^\S+@\S+\.\S+$/.test(formData.email)) newErrors.email = "Invalid email format.";
    if (!formData.requirement.trim()) newErrors.requirement = "Requirement description is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      toast.error("Please fill in all required fields correctly.");
      return;
    }
    setLoading(true);
    try {
      await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/user/send-email`, formData);
      toast.success("Email sent successfully!");
      setFormData({ name: "", email: "", requirement: "" });
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to send email.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container
      maxWidth={false}
      ref={emailFormRef}
      sx={{
        backgroundImage: `url('/images/formBg2.png'), url('/images/formBg1.png')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        padding: '20px',
        display: 'flex',
        minHeight: '500px',
        paddingTop: '20px',
        paddingBottom: '20px',
        position: 'relative',
      }}
    >
      <Container
        maxWidth="xl"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          width: '100%',
        }}
      >
        <Box sx={{
          flex: {
            xs: 0,
            sm: 1,
          }
        }}></Box>

        <Box sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          my: 4
        }}>
          <Box sx={{ mb: 3 }}>
            <PrimaryHeading sx={{ lineHeight: '42px' }}>
              Let’s discuss your <span style={{
                background: 'linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                color: 'transparent',
                backgroundClip: 'text'
              }}
              >requirement</span>
            </PrimaryHeading>
            <span>
              <svg width="66" height="7" viewBox="0 0 66 7" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect y="0.115234" width="66" height="6.00753" fill="url(#paint0_linear_114_3854)" />
                <defs>
                  <linearGradient id="paint0_linear_114_3854" x1="66" y1="3.19602" x2="0.192988" y2="-0.406406" gradientUnits="userSpaceOnUse">
                    <stop stopColor="#43B0D7" />
                    <stop offset="1" stopColor="#0D2663" />
                  </linearGradient>
                </defs>
              </svg>
            </span>
          </Box>
          <Box sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            mb: 2
          }}>
            <Box sx={{ width: { xs: '100%', md: '45%' }, py: 1 }}>
              <NCRFormLabel isRequired={true} sx={{ fontSize: '16px', pb: 1 }}>Name</NCRFormLabel>
              <TextField
                className='email-form-text-field'
                name='name'
                value={formData.name}
                placeholder='Enter your name'
                fullWidth
                onChange={handleChange}
                error={!!errors.name}
                helperText={errors.name}
              />
            </Box>
            <Box sx={{ width: { xs: '100%', md: '45%' }, py: 1 }}>
              <NCRFormLabel isRequired={true} sx={{ fontSize: '16px', pb: 1 }}>Email</NCRFormLabel>
              <TextField
                className='email-form-text-field'
                name='email'
                value={formData.email}
                placeholder='Enter your email'
                fullWidth
                onChange={handleChange}
                error={!!errors.email}
                helperText={errors.email}
              />
            </Box>
          </Box>
          <Box>
            <NCRFormLabel isRequired={true} sx={{ fontSize: '16px', pb: 1 }}>Requirement</NCRFormLabel>
            <TextField
              multiline
              minRows={4}
              className='email-form-text-field'
              name='requirement'
              value={formData.requirement}
              placeholder='Describe your requirement'
              sx={{ '& .MuiInputBase-root': { backgroundColor: 'white' } }}
              fullWidth onChange={handleChange}
              error={!!errors.requirement}
              helperText={errors.requirement}
            />
          </Box>
          <Box sx={{
            display: 'flex',
            justifyContent: 'flex-end'
          }}>
            <Button
              variant="outlined"
              sx={{
                fontFamily: 'Lato, sans-serif',
                borderRadius: '20px',
                background: 'linear-gradient(white, white), linear-gradient(270.29deg, #43B0D7 0.24%, #0D2663 99.75%)',
                my: 3,
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: '700',
                lineHeight: '16.8px',
                boxShadow: '0px 4px 4px 0px #0000001A',
              }}
              disabled={loading}
              value={formData.requirement}
              onClick={handleSubmit}
              endIcon={<img src="/images/sendArrowIcon.svg" alt="icon" style={{ width: 30, height: 30 }} />}
            >
              {loading ? "Please wait..." : "Send Message"}
            </Button>
          </Box>
        </Box>
      </Container>
    </Container>
  );
}
